import { ChevronLeft } from 'lucide-react'

/** URL de l'accueil du site WordPress — identique au lien du logo (voir BlueHeader). */
const WORDPRESS_HOME_URL = 'https://wp.massiliavoyages.fr/'

/**
 * Lien « Retour à l'accueil » affiché en haut des pages de résultats de vol.
 * Navigation externe (rechargement complet) vers le site WordPress.
 */
export function ResultsBackHome() {
  return (
    <a
      className="inline-flex w-fit items-center gap-1.5 text-sm font-medium text-brand-700 hover:text-brand-800"
      href={WORDPRESS_HOME_URL}
    >
      <ChevronLeft className="size-4" />
      <span>Retour à l&apos;accueil</span>
    </a>
  )
}
